var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fish-tree-select',{attrs:{"data":_vm.data1,"multiple":""},on:{"change":_vm.changeHandler},model:{value:(_vm.v),callback:function ($$v) {_vm.v=$$v},expression:"v"}}),_vm._v(" "),_c('fish-tree-select',{attrs:{"data":_vm.data,"multiple":""},on:{"change":_vm.changeHandler},model:{value:(_vm.v1),callback:function ($$v) {_vm.v1=$$v},expression:"v1"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065a3d18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/components/DemoTreeSelectMultiple.vue
// module id = 747
// module chunks = 1